const utils = {
    extend(target, ...sources) {
        sources.forEach((src) => {
            if (src) Object.assign(target, src);
        });
        return target;
    },
    on(el, events, handler, opts) {
        events
            .split(" ")
            .forEach((ev) =>
                el.addEventListener(ev, handler, opts || false),
            );
    },
    off(el, events, handler) {
        events
            .split(" ")
            .forEach((ev) => el.removeEventListener(ev, handler, false));
    },
    css(el, styles) {
        Object.assign(el.style, styles);
    },
    clamp(v, mn, mx) {
        return Math.min(Math.max(v, mn), mx);
    },
    lerp(a, b, t) {
        return a + (b - a) * t;
    },
    el(tag, cls, styles) {
        const e = document.createElement(tag);
        if (cls) e.className = cls;
        if (styles) utils.css(e, styles);
        return e;
    },
    uid() {
        return "wcpg-" + Math.random().toString(36).slice(2, 9);
    },
    isTouch() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    },
    loadImage(src) {
        return new Promise((res) => {
            const img = new Image();
            img.onload = () => res(img);
            img.onerror = () => res(img);
            img.src = src;
        });
    },
    debounce(fn, ms) {
        let t;
        return (...a) => {
            clearTimeout(t);
            t = setTimeout(() => fn(...a), ms);
        };
    },
};

export default utils;
